import { render } from "./DocumentSearch.vue?vue&type=template&id=29f363e1&scoped=true&ts=true"
import script from "./DocumentSearch.vue?vue&type=script&lang=ts"
export * from "./DocumentSearch.vue?vue&type=script&lang=ts"

import "./DocumentSearch.vue?vue&type=style&index=0&id=29f363e1&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-29f363e1"]])

export default __exports__